import { http } from '@/core/api';
import { executeRequest } from '@/core/either';
import type { ApiResult } from '@/core/either';
import type {
  InvitationCountResponse,
  InvitationStatsRequestParams,
  InvitationStatsResponse,
  CampaignInformationResponse,
  ReferralCampaignResponse,
  ReferralLinkNameResponse,
} from '../types/referral.type';

export const referralService = {
  /**
   * Llama al endpoint de historial de invitaciones (invitation-stats).
   * @param params - Parámetros del API (page 0-based, size, sort, status, search).
   * @returns Promesa Either (ApiResult<InvitationStatsResponse>).
   */
  getInvitations(
    params: InvitationStatsRequestParams
  ): Promise<ApiResult<InvitationStatsResponse>> {
    return executeRequest(() =>
      http.get<InvitationStatsResponse>('discounts/b2b/campaigns/promoters/invitation-stats', {
        params,
      })
    );
  },

  /**
   * Obtiene el conteo de invitaciones (total referidos, referidos del mes actual).
   * @returns Promesa Either (ApiResult<InvitationCountResponse>).
   */
  getInvitationCount(): Promise<ApiResult<InvitationCountResponse>> {
    return executeRequest(() =>
      http.get<InvitationCountResponse>('discounts/b2b/campaigns/promoters/referral-stats')
    );
  },

  /**
   * Obtiene la campaña de gamificación/referidos con niveles y progreso del cliente.
   * @returns Promesa Either (ApiResult<ReferralCampaignResponse>).
   */
  getLevels(): Promise<ApiResult<ReferralCampaignResponse>> {
    return executeRequest(() =>
      http.get<ReferralCampaignResponse>('discounts/b2b/campaigns/promoters')
    );
  },

  /**
   * Obtiene la información de la campaña (pasos del programa de referidos).
   * @returns Promesa Either (ApiResult<CampaignInformationResponse>).
   */
  getCampaignInformation(): Promise<ApiResult<CampaignInformationResponse>> {
    return executeRequest(() =>
      http.get<CampaignInformationResponse>(
        'discounts/b2b/campaigns/campaign-information'
      )
    );
  },

  /**
   * Obtiene el nombre de la empresa para el link de referidos.
   * @returns Promesa Either (ApiResult<ReferralLinkNameResponse>).
   */
  getCompanyName(): Promise<ApiResult<ReferralLinkNameResponse>> {
    return executeRequest(() =>
      http.get<ReferralLinkNameResponse>(
        'discounts/b2b/referral/referral-link-name'
      )
    );
  },


  /**
   * Actualiza el nombre de la empresa.
   * @param name - Nombre de la empresa.
   * @returns Promesa Either (ApiResult<void>).
   */
  updateCompanyName(name: string): Promise<ApiResult<void>> {
    return executeRequest(() =>
      http.patch<void>(
        `discounts/b2b/referral/referral-link-name?referralLinkName=${name}`
      )
    );
  },

  /**
   * Envía el evento cuando el usuario copia el link de referidos.
   * @returns Promesa Either (ApiResult<void>).
   */
  createReferralLinkCopiedEvent(): Promise<ApiResult<void>> {
    return executeRequest(() =>
      http.post<void>(
        'discounts/b2b/referral/referral-copy-events'
      )
    );
  },
};
